export default __webpack_public_path__ + "static/media/niifi-logo.425a57ff.svg";